import React, { useState, useEffect, useCallback } from "react";
// Default theme
import "@splidejs/react-splide/css";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { BsFillCalendarCheckFill } from "react-icons/bs";
import { FaCheck } from 'react-icons/fa';
import { useSelector } from "react-redux";
import { Link, useNavigate , useParams } from "react-router-dom";
import moment from "moment";
import ReactImageFallback from "react-image-fallback";
import ReactPlayer from "react-player";
import { Button, Modal } from 'react-bootstrap';
import { toast, ToastContainer } from "react-toastify";
import Cookies from "js-cookie";
// components
import Footer1 from "../components/Footers/Footer1.component";
import AuthHeader from "../components/Headers/AuthHeader.component";
import Loader from "../components/Loader.component";
import BidsList from "../components/BidsList.component";
import ReactStars from "react-rating-stars-component";

// images
import featuredImg from "../assets/images/default_featured_img.png";
import defaultUser from "../assets/images/default_profile_pic.jpg";


export default function JobDetail() {
  let navigate = useNavigate();
  const { id } = useParams();
  
  // Local State  
  const [posts, setPosts] = useState("");
  const [comment, setComment] = useState("");
  const [price, setPrice] = useState("");
  const [flag, setFlag] = useState('');
  const [error, setError] = useState('');
  const [isPiad, setisPiad] = useState(false);
  const [disableOffer, setDisableOffer] = useState("");
  const [currentUserBid, setCurrentUserBid] = useState("");

  // react-bootstrap
  const [review, setReview] = useState("");
  const [rateStar, setRateStar] = useState(0);
  const [showReview, setShowReview] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChangeReview = (e) => {
    let val = e.target.value;
    setReview(val);
  }
  const ratingChanged = (newRating) => {
    setRateStar(newRating);
  };
  // submit form 
  const handleSubmitReview = async (e) => {
    e.preventDefault();

    console.log(posts?.assign_post?.user_id);

    let formData = new FormData();
    formData.append("sender_id", userData?.id);
    formData.append("receiver_id", posts?.assign_post?.user_id);
    formData.append("stars", rateStar);
    formData.append("description", review);
    
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/reviews`, {
      method: "POST", 
      headers: {
        "Authorization": `Bearer ${token}`
      },
      body: formData
    })
    .then(r => r.json())
    .then(response => {
      if(response.success){
        setShowReview(false);
        toast.success("Your Review Submitted. Thankyou for your Review.");
      } else {
        toast.error(response.message);
      }
    })

  }
  

  // Redux State
  const userData = useSelector((state) => state.auth.data);
  const token = useSelector((state) => state.auth.token);

  useEffect(() => {
    getAllPosts();    
  }, [disableOffer, currentUserBid]);


  // getting all posts
  const getAllPosts = useCallback(async () => {
    if (id !== undefined) {
      await fetch(`${process.env.REACT_APP_BASE_URL}/api/posts?post_id=${id}`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      })
        .then((r) => r.json())
        .then((response) => {
          if (response.success) {
           
            if(response.records.data.length > 0 && response.records.data[0].id == Cookies.get(`jobid${response.records.data[0].id}`) && Cookies.get(`isPaid${response.records.data[0].id}`) == "paid"){
              setisPiad(true);
              setPosts(response.records.data[0]);
            }else if(response.records.data.length > 0 && response.records.data[0].assign_post !== null) {
              Object.keys(response.records.data[0].assign_post).length > 0 && response.records.data[0].assign_post.user_id === userData?.id &&
              setisPiad(true);
              setPosts(response.records.data[0]);
            } else if(userData?.role === 3){
              setisPiad(true);
              setPosts(response.records.data[0]);
            } else {
              navigate("/jobs", {replace: true});
            }
          } else {
            console.log(response);
          }
        });
    }
  }, []);

  // form fields change
  const handleChangePrice = (e) => {
    let val = e.target.value;
    setPrice(val);
  }
  const handleChangeComment = (e) => {
    let val = e.target.value;
    setComment(val);
  }

  // submit form 
  const handleSubmit = async (e) => {
    e.preventDefault();
    let formData = new FormData();
    formData.append("provider_id", userData?.id);
    formData.append("post_id", posts?.id);
    formData.append("price", price);
    formData.append("description", comment);

    await fetch(`${process.env.REACT_APP_BASE_URL}/api/bids`, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
      },
      body: formData
    })
      .then(r => r.json())
      .then(response => {
        if (response) {
          handleClose();
          // setFlag({ type: "success", message: "Your Offer sent successfully." });
          e.target.reset();
          setDisableOffer(true);
          toast.success("Your Offer sent successfully.");
        } else {
          // setFlag({ type: "error", message: response.message });
          toast.error(response.message);
        }
      })
  }

  // mark job as completed 
  const handleJobCompleted = async (e) => {
    e.preventDefault();
    let statusForm = new FormData();
    statusForm.append("status", 3);
    
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/posts/${posts?.id}`, {
      method: 'POST',
      headers: {
        "Authorization": `Bearer ${token}`,
      },
      body: statusForm
    })
      .then(r => r.json())
      .then(response => {
        if (response.success) {
          toast.success("Job has been marked as Completed.");
          setShowReview(true);
        }
      })
  }

  const startChatBtn = () => {
    if(userData?.role === 3){
      // return <Navigate to={`/messages/${posts?.assign_post?.user_id}`} replace />
      navigate(`/chat?post_id=${posts?.id}`, { replace: true });
    } else if(userData?.role === 2){
      // return <Navigate to={`/messages/${posts?.customer_id}`} replace />
      navigate(`/chat?post_id=${posts?.id}`, { replace: true });
    }
  }

  return (
    <>
      <AuthHeader />
      {/* <!-- MAIN START --> */}
      <main>        
        <section className="bds-main-section">
          {!posts ? (
            <Loader />
          ) : (
            <div className="container">
              <div className="row">
                <div className="col-lg-7 col-xl-8">
                  <div className="bds-servicedetailtitle px-0">
                    <div className="bds-tehelpop">
                      <ul className="bds-tags">
                        <li>
                          <h5>
                            <Link to="/jobs">
                              {posts?.service?.service_name}
                            </Link>
                          </h5>
                        </li>
                      </ul>
                      <h3>{posts?.title}</h3>
                      {/* <ul className="bds-blogviewdates">
                          <li>
                            <i className="fas fa-star bds-yellow"></i>
                            <em>5.0</em>
                            <span>(12,039)</span>
                          </li>
                          <li>
                            <span>
                              <i className="icon-eye"></i> 856,854
                            </span>
                          </li>
                          <li className="bds-likev2">
                              <Link to="#">
                              <a>
                                <i className="icon-heart"></i> save
                              </a>
                            </Link>
                          </li>
                        </ul> */}
                    </div>
                  </div>

                  <Splide
                    className="bds-sync"
                    options={{
                      type: "fade",
                      pagination: false,
                      cover: true,
                    }}
                  >
                    {posts?.videos?.map((item, idx) => (
                      <SplideSlide key={idx} className="splide-slider-r">
                        <figure className="bds-sync__content single-post-slide">
                          <Link to="#" className="bds-themegallery d-block">
                              <ReactPlayer
                                key={idx}
                                url={`https://3bidsapp.com/dev/public/storage/${item?.filepond?.filepath}`}
                                controls={true}
                                className="slide-video"
                              />
                              {/* <span className="bds-featuretag">FEATURED</span> */}
                              {/* <span className="bds-video__icon"></span> */}                            
                          </Link>
                        </figure>
                      </SplideSlide>
                    ))}
                    {posts?.images?.map((item, idx) => (
                      <SplideSlide key={idx} className="splide-slider-r">
                        <figure className="bds-sync__content single-post-slide">
                          <Link to="#" className="bds-themegallery d-block">
                              <ReactImageFallback
                                src={`https://3bidsapp.com/dev/public/storage/${item?.filepond?.filepath}`}
                                fallbackImage={featuredImg}
                                initialImage={featuredImg}
                                alt={item?.filepond?.filename}
                                className="slide-img"
                              />
                              {/* <span className="bds-featuretag">FEATURED</span> */}
                              {/* <span className="bds-video__icon"></span> */}                            
                          </Link>
                        </figure>
                      </SplideSlide>
                    ))}

                    {/* <SplideSlide>
                        <figure className="bds-sync__content">
                            <Link to="#">
                            <a className="bds-themegallery">
                              <img src={slide2} alt="Image Description" />
                              <span className="bds-featuretag">FEATURED</span>
                              <span className="bds-video__icon"></span>
                            </a>
                          </Link>
                        </figure>
                      </SplideSlide>
                      */}
                  </Splide>
                  <div className="bds-servicedetail mt-5 bds-box">
                    <div className="bds-text-wrapper">
                      <div className="bds-main-title-holder">
                        <div className="bds-main-description mb-3">
                          <h6 className="mb-0 d-flex align-items-center">
                            { posts?.status === 3 ? "" : "Job Assigned:" }
                            <small className="ms-3">
                              {
                                posts?.status === 1 && 
                                <span className="badge bg-warning">
                                  Not Assign 
                                </span>
                              }
                              {
                                posts?.status === 2 && 
                                <span className="badge bg-success">
                                  Assigned
                                </span>
                              }
                              
                            </small>
                          </h6>
                        </div>
                        <div className="bds-main-description mb-3">
                          <h6 className="mb-1">Location</h6>
                          <small>{posts?.address}</small>
                        </div>
                        <div className="bds-main-description">
                          <h4>Scope of Work</h4>
                          <p>{posts?.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-xl-4">
                  <aside>
                    <div className="bds-asideholder bds-sidebartabholder">
                      <div className="bds-box py-4">
                        <h5>Task Completion Date</h5>
                        <p className="text-sky-blue fw-bold mb-0 d-flex align-items-center">
                          {" "}
                          <BsFillCalendarCheckFill />
                          <span className="ms-2">
                            { console.log(posts) }
                            {moment(posts?.task_completion_date).format(
                              "MMMM Do, YYYY"
                            )}
                          </span>
                        </p>
                        <h4 className="d-flex mt-4">
                          <span>Price</span>
                          <span className="text-sky-blue ms-auto d-block">
                            ${posts?.price}
                          </span>
                        </h4>
                        {userData?.role !== 3 && posts?.status == 1 && posts?.assign_post == null && !currentUserBid && (
                          <div className="bds-sidebarpkg__btn pt-0">
                            <Button
                              className="bds-btn-solid-lg w-100 mt-2 shadow-none"
                              onClick={handleShow}
                            >
                              Make an Offer
                              <i className="icon-arrow-right"></i>
                            </Button>
                          </div>
                        )   
                        }

                        {
                          posts?.state == 2 && Object.keys(posts?.assign_post).length > 0 && 
                          <p className="btn bg-gray fw-bold small text-uppercase theme-rounded w-100 disabled mt-3" disabled>Job Assigned</p>
                        }

                        {userData?.role == 3 && posts?.customer_id === userData?.id && posts?.status === 2 && (
                          <div className="bds-sidebarpkg__btn pt-0">
                            <Button
                              className="success_btn theme-rounded w-100 mt-2 shadow-none d-flex align-items-center justify-content-center"
                              onClick={(e) => handleJobCompleted(e)}
                            >
                              <FaCheck />
                              <span className="ms-2">Mark Job as Completed</span>
                            </Button>
                          </div>
                        )}
                        
                          {
                            posts?.status === 2 && posts?.assign_post !== null &&
                            <button type="button" onClick={() => startChatBtn()} className="btn w-100 d-block btn-outline-secondary mt-3 theme-rounded">
                              Start Chat
                            </button>
                          }

                        {
                          posts?.status == 3 && <p className="text-center text-muted fw-bold mb-0 mt-4">The Job is Completed</p>
                        }

                      </div>
                    </div>
                    <div className="bds-asideholder bds-box py-2">
                      <div className="bds-asideboxv2">
                        <div className="bds-asideprostatus">
                          <figure>
                            <ReactImageFallback
                              src={`https://3bidsapp.com/dev/public/storage/${posts?.customer?.profile_image}`}
                              fallbackImage={defaultUser}
                              initialImage={defaultUser}
                              alt="Image Description"
                              layout="responsive"
                              width={100}
                              height={100}

                              className="profile_photo_100"
                            />
                            {posts?.customer?.active_status ? (
                              <figcaption
                                className="bds-usertag bds-online bds-theme-tooltip"
                                data-tippy-content="Online"
                              ></figcaption>
                            ) : (
                              <figcaption
                                className="bds-usertag bds-offline bds-theme-tooltip"
                                data-tippy-content="Offline"
                              ></figcaption>
                            )}
                          </figure>
                        </div>
                        <div className="bds-icondetails">
                          <div className="bds-cardtitle">
                            <Link to="#">
                              {posts?.customer?.first_name &&
                                posts?.customer?.last_name !== null
                                ? posts?.customer?.first_name +
                                " " +
                                posts?.customer?.last_name
                                : posts?.customer?.name}
                            </Link>
                          </div>
                          <ul className="bds-blogviewdates bds-blogviewdatessm">
                            <li>
                              <em className="me-2 ">Account Status:</em>
                              {!posts?.customer?.account_status ? (
                                <span>Not Verified</span>
                              ) : (
                                <span className="text-success fw-bold text-uppercase">
                                  Verified
                                </span>
                              )}
                            </li>
                          </ul>
                          <div className="bds-sidebarcontent">
                            <div className="bds-sidebarinnertitle">
                              <span>Location:</span>
                              <h6 className="lh-sm">{posts?.address}</h6>
                            </div>
                          </div>
                          <div className="bds-sidebarcontent">
                            <div className="bds-sidebarinnertitle">
                              <span>Success rate:</span>
                              <h6>
                                {posts?.customer?.no_of_jobs_completed}
                                Completed
                              </h6>
                            </div>
                            <div className="progress bds-profileprogress">
                              <div
                                className="progress-bar"
                                role="progressbar"
                                style={{
                                  width: `${posts?.customer?.no_of_jobs_completed}%`,
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </aside>
                </div>
              </div>
              
              {/* list of all bids */}
              <BidsList 
                postID={posts?.id}
                disableOffer={disableOffer}
                setCurrentUserBid={setCurrentUserBid}
                posts={posts}
              />

            </div>
          )}
        </section>
      </main>
      {/* <!-- MAIN END --> */}

      {/* <!-- Modal --> */}
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body className="p-4">
          <h3>Make an Offer</h3>

          <form onSubmit={(e) => handleSubmit(e)}>
            <div className="form-group flex-column align-items-start px-0">
              <h6>Place Your Price</h6>
              <div className="bds-placeholderholder border">
                <span className="ps-3">$</span>
                <input
                  name="price"
                  type="number"
                  className="form-control bds-themeinput ps-2"
                  placeholder="Project Price"
                  value={price}
                  onChange={(e) => handleChangePrice(e)}
                />
              </div>
            </div>

            <div className="form-group flex-column align-items-start px-0">
              <h6>Cover Letter</h6>
              <div className="bds-placeholderholder border theme-rounded-25 p-2">
                <textarea
                  name="description"
                  className="form-control bds-themeinput ps-2"
                  value={comment}
                  onChange={(e) => handleChangeComment(e)}
                />
              </div>
            </div>

            <button className="btn bds-btn-solid-lg btn-primary ms-auto d-block" type="submit">Submit your offer</button>
          </form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showReview}
        onHide={() => setShowReview(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body className="p-4">
          <h3 className='text-success text-center'>Congratulations! 🎉</h3>
          <h6 className="mt-0 text-center">Please Share your review about this job.</h6>

          <form onSubmit={(e) => handleSubmitReview(e)}>
            <div className="form-group flex-column align-items-start px-0">
              <h6>How do you rate?</h6>
              <div className="d-flex align-items-center">
                <ReactStars
                  count={5}
                  onChange={ratingChanged}
                  size={24}
                  activeColor="#ffd700"
                />
                <small className="fw-bold ms-2 my-0">
                  { rateStar == 0 && "" }
                  { rateStar == 1 && "Bad Service" }
                  { rateStar == 2 && "Poor Service" }
                  { rateStar == 3 && "Good Service" }
                  { rateStar == 4 && "Very Good Service" }
                  { rateStar == 5 && "Excellent Service" }
                </small>

              </div>
            </div>

            <div className="form-group flex-column align-items-start px-0">
              <h6>Write your Review</h6>
              <div className="bds-placeholderholder border theme-rounded-25 p-2">
                <textarea
                  name="description"
                  className="form-control bds-themeinput ps-2"
                  placeholder="Write Your Review"
                  value={review}
                  onChange={(e) => handleChangeReview(e)}
                />
              </div>
            </div>
            <button className="btn bds-btn-solid-lg btn-primary ms-auto d-block" type="submit">Submit your Review</button>
          </form>
        </Modal.Body>
      </Modal>

      <Footer1 />
      <ToastContainer />
    </>
  );
}
